<script setup lang="ts">
import Button from '../design-system/button.vue';
const emits = defineEmits<{ (e: 'play'): void }>();
</script>

<template>
  <div class="absolute h-full w-full">
    <div
      class="absolute h-full w-full flex-center flex-col z-1 text-base-priority gap-2 dark:bg-dark-800/80 bg-light-50/70"
    >
      <Button
        element-name="real-play"
        padding="wide"
        class="capitalize min-w-[50%] max-w-[75%] justify-center text-center"
        @click="emits('play')"
      >
        {{ $t('demo-play') }}
      </Button>
    </div>
  </div>
</template>
<style scoped></style>
